import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LOGIN_URL, REGISTER_URL } from '../constants';

export default function Auth() {
  const [isRegistering, setIsRegistering] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const url = isRegistering ? REGISTER_URL : LOGIN_URL;

  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const validate = () => {
    const newErrors = {};
    if (!form.email) newErrors.email = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(form.email)) newErrors.email = 'Invalid email format';
    if (!form.password) newErrors.password = 'Password is required';
    else if (form.password.length < 6) newErrors.password = 'Password too short';

    if (isRegistering) {
      if (!form.firstName) newErrors.firstName = 'First name required';
      if (!form.lastName) newErrors.lastName = 'Last name required';
      if (!form.confirmPassword) newErrors.confirmPassword = 'Confirm your password';
      else if (form.password !== form.confirmPassword) {
        newErrors.confirmPassword = 'Passwords do not match';
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);

    try {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          firstName: form.firstName,
          lastName: form.lastName,
          email: form.email,
          password: form.password,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        toast.error(data.message || 'Something went wrong');
        return;
      }

      localStorage.setItem('user', JSON.stringify(data.user));
      localStorage.setItem('token', data.token);

      toast.success('Login successful!');
      setTimeout(() => navigate('/companies'), 1000);
    } catch (err) {
      console.error(err);
      toast.error('Network or server error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-4">
      <ToastContainer position="top-right" />
      <div className="w-full max-w-md bg-white shadow-xl rounded-xl p-8">
        {/* Logo */}
        <div className="flex justify-center mb-4">
          <img src={logo} alt="Logo" className="w-56 mb-2" />
        </div>

        {/* Tabs */}
        <div className="flex justify-between mb-6 border-b border-gray-200">
          <button
            className={`flex-1 text-center pb-2 font-medium ${
              !isRegistering ? 'border-b-2 border-primary text-primary' : 'text-gray-500'
            }`}
            onClick={() => setIsRegistering(false)}
          >
            Log in
          </button>
          <button
            className={`flex-1 text-center pb-2 font-medium ${
              isRegistering ? 'border-b-2 border-primary text-primary' : 'text-gray-500'
            }`}
            onClick={() => setIsRegistering(true)}
          >
            Sign up
          </button>
        </div>

        {/* Heading */}
        <h2 className="text-xl font-semibold text-center mb-1">
          {isRegistering ? 'Create your account' : 'Log in below'}
        </h2>
        <p className="text-sm text-gray-500 text-center mb-6">
          {isRegistering ? 'Complete Signup form below.' : 'Enter email and password below'}
        </p>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-4">
          {isRegistering && (
            <>
              <div>
                <input
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  value={form.firstName}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-full bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary"

                />
                {errors.firstName && (
                  <p className="text-red-500 text-sm mt-1">{errors.firstName}</p>
                )}
              </div>
              <div>
                <input
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  value={form.lastName}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-full bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary"

                />
                {errors.lastName && (
                  <p className="text-red-500 text-sm mt-1">{errors.lastName}</p>
                )}
              </div>
            </>
          )}

          <div>
            <input
              type="email"
              name="email"
              placeholder="E-mail"
              value={form.email}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-full bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary"

            />
            {errors.email && (
              <p className="text-red-500 text-sm mt-1">{errors.email}</p>
            )}
          </div>

          <div>
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={form.password}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-full bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary"

            />
            {errors.password && (
              <p className="text-red-500 text-sm mt-1">{errors.password}</p>
            )}
          </div>

       
            {!isRegistering && (
              <div className="text-right text-sm">
                <button
                  type="button"
                  onClick={() => navigate('/forgot-password')}
                  className="text-primary hover:underline"
                >
                  Forgot Password?
                </button>
              </div>
            )}


          {isRegistering && (
            <div>
              <input
                type="password"
                name="confirmPassword"
                placeholder="Confirm Password"
                value={form.confirmPassword}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded-full bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary"

              />
              {errors.confirmPassword && (
                <p className="text-red-500 text-sm mt-1">{errors.confirmPassword}</p>
              )}
            </div>
          )}

          <button
            type="submit"
            className="w-full bg-primary text-white py-2 rounded-full font-semibold hover:bg-opacity-90 disabled:opacity-50"
            disabled={loading}
          >
            {loading ? (isRegistering ? 'Signing up...' : 'Logging in...') : (isRegistering ? 'Sign up' : 'Log in')}
          </button>
        </form>
      </div>
    </div>
  );
}


